import axios from "@/plugins/axios";

export const state = () => ({
  site_info: {},
});

export const mutations = {
  SET_SITE_INFO(state, payload) {
    state.site_info = payload;
  },
};

export const actions = {
  async fetchSiteInfo({ state, commit, getters }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`pos/site-settings/1`)
        .then((res) => {
          commit("SET_SITE_INFO", res.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetSiteName(state) {
    return state.site_info.name ? state.site_info.name : null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
